import PropTypes from "prop-types";

import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CheckIcon from "@material-ui/icons/Check";

import loadingBackdropStyles from "features/budget/wizard/views/loading-backdrop/loading-backdrop.styles";

const useStyles = makeStyles(loadingBackdropStyles);

function LoadingBackdrop({ loading, success }) {
  const classes = useStyles();

  if (loading) {
    return (
      <div className={classes.content}>
        <Typography variant="h4" gutterBottom>
          Generating Budget...
        </Typography>
        <CircularProgress color="inherit" />
      </div>
    );
  }

  if (success) {
    return (
      <div className={classes.content}>
        <Typography variant="h3" gutterBottom color="primary">
          Budget Scenario
        </Typography>
        <Typography variant="h4" gutterBottom className={classes.uppercaseText}>
          Saved
        </Typography>
        <CheckIcon fontSize="large" />
      </div>
    );
  }

  return null;
}

LoadingBackdrop.propTypes = {
  loading: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
};

export default LoadingBackdrop;
